var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _rect2, _circle6, _circle7, _circle8, _circle9, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLicensePlate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 50,
    viewBox: "0 0 89 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 1.5,
    width: 81,
    height: 40,
    rx: 6.5,
    fill: "#E62645",
    stroke: "#A7163E",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 7,
    r: 2,
    fill: "#E62645"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 36,
    r: 2,
    fill: "#E62645"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 7,
    r: 2,
    fill: "#A7163E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 7,
    r: 2,
    fill: "#A7163E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 36,
    r: 2,
    fill: "#E62645"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 8.5,
    width: 81,
    height: 40,
    rx: 6.5,
    fill: "#FFEADB",
    stroke: "#EF7C00",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 2,
    fill: "#EF7C00"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 43,
    r: 2,
    fill: "#EF7C00"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 14,
    r: 2,
    fill: "#EF7C00"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 43,
    r: 2,
    fill: "#EF7C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3343 32.8343L23.3212 27.0331L20.626 31.8122H19.6709L16.9887 27.1575V32.8343H15V23.1657H16.7532L20.1811 29.174L23.5567 23.1657H25.2968L25.323 32.8343H23.3343Z",
    fill: "#EF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0984 24.989H30.1676V23.1657H38.1487V24.989H35.2179V32.8343H33.0984V24.989Z",
    fill: "#EF7C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1244 32.8343L43.3581 30.1409H43.2534H41.4086V32.8343H39.2891V23.1657H43.2534C44.0646 23.1657 44.7668 23.3085 45.3599 23.5939C45.9617 23.8794 46.424 24.2845 46.7468 24.8094C47.0695 25.3343 47.2309 25.9558 47.2309 26.674C47.2309 27.3923 47.0651 28.0138 46.7337 28.5387C46.4109 29.0543 45.9487 29.4503 45.3468 29.7265L47.4009 32.8343H45.1244ZM45.0851 26.674C45.0851 26.1308 44.9194 25.7164 44.588 25.4309C44.2565 25.1363 43.7724 24.989 43.1357 24.989H41.4086V28.3591H43.1357C43.7724 28.3591 44.2565 28.2118 44.588 27.9171C44.9194 27.6225 45.0851 27.2081 45.0851 26.674Z",
    fill: "#EF7C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8671 23.1657V32.8343H49.7475V24.9613H47.9158V23.1657H51.8671Z",
    fill: "#EF7C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3008 31.0111V32.8343H53.3796V31.384L56.9121 27.8619C57.2872 27.4843 57.5402 27.1621 57.671 26.895C57.8018 26.6188 57.8672 26.3471 57.8672 26.0801C57.8672 25.6934 57.7408 25.3987 57.4878 25.1961C57.2436 24.9843 56.8816 24.8785 56.4019 24.8785C56.0006 24.8785 55.6387 24.9613 55.3159 25.1271C54.9932 25.2836 54.7228 25.523 54.5048 25.8453L52.9609 24.7956C53.3185 24.2339 53.8113 23.7965 54.4393 23.4834C55.0673 23.1611 55.7869 23 56.5981 23C57.2785 23 57.8716 23.1197 58.3775 23.3591C58.8921 23.5893 59.289 23.9208 59.5681 24.3536C59.856 24.7772 59.9999 25.279 59.9999 25.8591C59.9999 26.384 59.8952 26.8766 59.6859 27.337C59.4765 27.7974 59.0709 28.3223 58.4691 28.9116L56.3626 31.0111H60.3008Z",
    fill: "#EF7C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0749 33C64.3161 33 63.6401 32.802 63.0469 32.4061C62.4538 32.0101 61.9872 31.4392 61.647 30.6934C61.3155 29.9383 61.1498 29.0405 61.1498 28C61.1498 26.9595 61.3155 26.0663 61.647 25.3204C61.9872 24.5654 62.4538 23.9899 63.0469 23.5939C63.6401 23.198 64.3161 23 65.0749 23C65.8338 23 66.5098 23.198 67.1029 23.5939C67.696 23.9899 68.1583 24.5654 68.4897 25.3204C68.8299 26.0663 69 26.9595 69 28C69 29.0405 68.8299 29.9383 68.4897 30.6934C68.1583 31.4392 67.696 32.0101 67.1029 32.4061C66.5098 32.802 65.8338 33 65.0749 33ZM65.0749 31.1077C65.6331 31.1077 66.0693 30.8545 66.3833 30.3481C66.706 29.8416 66.8674 29.0589 66.8674 28C66.8674 26.9411 66.706 26.1584 66.3833 25.6519C66.0693 25.1455 65.6331 24.8923 65.0749 24.8923C64.5254 24.8923 64.0893 25.1455 63.7665 25.6519C63.4525 26.1584 63.2955 26.9411 63.2955 28C63.2955 29.0589 63.4525 29.8416 63.7665 30.3481C64.0893 30.8545 64.5254 31.1077 65.0749 31.1077Z",
    fill: "#EF7C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLicensePlate);
export default __webpack_public_path__ + "static/media/imgLicensePlate.e8238d35d9cd656e88624006f0a78ca4.svg";
export { ForwardRef as ReactComponent };